import { IInvoiceEntity } from "../../models";

const getCustomerReference = (customerId: number, options: IInvoiceEntity[]) => {
    return options.find((x) => x.customerId === customerId)?.customerUserId;
};

export { getCustomerReference };
